import "./HomePage.css";

function HomePage() {
  return (
    <div className="home-page-container">
      <div className="hero-image-container">
        <img
          src="/IAN_9864-with-border.jpg"
          alt="Pomona Park"
          className="hero-image"
        />
        {/* <h1 className="hero-text">“Youthful optimism with lyrical charm”</h1> */}
      </div>
    </div>
  );
}

export default HomePage;
